import { render, staticRenderFns } from "./CompetitionRegistrationInfo.vue?vue&type=template&id=5c76285c&scoped=true"
import script from "./CompetitionRegistrationInfo.vue?vue&type=script&lang=js"
export * from "./CompetitionRegistrationInfo.vue?vue&type=script&lang=js"
import style0 from "./CompetitionRegistrationInfo.vue?vue&type=style&index=0&id=5c76285c&prod&lang=css"
import style1 from "./CompetitionRegistrationInfo.vue?vue&type=style&index=1&id=5c76285c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c76285c",
  null
  
)

export default component.exports